import React from 'react'

function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-semibold text-gray-900 mb-4">404</h1>
        <p className="text-2xl font-semibold text-gray-600">Page Not Found</p>
      </div>
    </div>
  )
}

export default NotFound